export default {"src":"/_next/static/media/safari mobile.c5ddc1e0.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};